module.exports = __webpack_public_path__ + "static/media/background-text.47e1b79f.gif";